import {SmartComponent} from "smart-component-js";

class InlineContactUsComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "InlineContactUsComponent";
        super(element, parentComponent, params);

        this.$el = $(element);
        this.$cta = this.$el.find('.btn-mrng');

        this.$header = $('header');
        this.$ICU = $('#ICU-popup');
        this.$ICUClose = this.$ICU.find('.close');
        this.$formWrp = this.$ICU.find('#form-wrapper');
        this.$typWrp = this.$ICU.find('#typ-wrapper');

        this.elTop = this.$el.offset().top

        this.init();
    }

    init() {
        window.addEventListener('CU-REST-SUBMIT', () => {
            this.$typWrp.show();
            this.$formWrp.hide();
        });
        this.$cta.click(() => {
            this.$ICU.find('[name="recaptchaToken"],[name="recaptchaRandom"]').val('');
            this.$typWrp.hide();
            this.$formWrp.show();
            this.$ICU.show();
        });
        this.$ICUClose.click(() => {
            this.$ICU.hide();
        });
        $(window).on('resize', () => {
            this.elTop = this.$el.offset().top
        });
        $(document).scroll(() => {
            if (this.$el.is(':visible')) {
                let top = $('html, body').scrollTop();

                if (this.$header.length > 0) {
                    top += parseInt(this.$header.height());
                }

                let tmpTop = parseInt(this.$el.offset().top);
                if (!this.$el.is('.fly') && !!tmpTop && tmpTop > this.elTop) {
                    this.elTop = tmpTop;
                }

                console.log("top:" + top);
                console.log("elTop:" + this.elTop);

                if (this.elTop < (top)) {
                    this.$el.find('.btn-mrng').html(KD_MARANGONI_PAGE_TRANSLATIONS["marangoni.mazecontact.cta.short"]);
                    this.$el.addClass("fly");
                } else {
                    this.$el.find('.btn-mrng').html(KD_MARANGONI_PAGE_TRANSLATIONS["marangoni.mazecontact.cta"]);
                    this.$el.removeClass("fly");
                }
            }
        });
    }
}

export default InlineContactUsComponent;